import React,{useState,useEffect} from 'react'
import { Row, Col, Container } from "react-bootstrap"
import { makeStyles, useTheme,  withStyles, } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PaymentIcon from '@material-ui/icons/Payment';
import ReceiptIcon from '@material-ui/icons/Receipt';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import { InputGroup, InputGroupAddon, Input } from 'reactstrap';
import InputLabel from '@material-ui/core/InputLabel';
import {TextField, Select, FormGroup} from '@material-ui/core';
import { UncontrolledCollapse,Form, Collapse, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ButtonToggle } from "reactstrap";
import {Accordion,Button,DropdownButton,ButtonGroup,Dropdown,Modal} from "react-bootstrap"
import { Link , Redirect} from 'react-router-dom';
import {toast , ToastContainer} from "react-toastify"
import { Tooltip } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'typeface-roboto';
import CreditCardInput from 'react-credit-card-input';
import "../App.css"
import Axios from 'axios';
import { base_url } from '../globalConstants';



const cancel={
    color:"darkblue",
    paddingRight: "27px",
    paddingLeft: "27px",
    paddingTop: "15px",
    paddingBottom: "17px",
    borderRadius:"25px",
    border:"none",
    float:"right",
    
  }

  const buttonstyle={
    color:"darkblue",
    backgroundColor:"skyblue",
    paddingRight: "27px",
    paddingLeft: "27px",
    paddingTop: "15px",
    paddingBottom: "17px",
    textAlign: "center",
    textDecoration: "none",
    borderRadius:"25px",
    border: "3px solid",
    float:"right",
    
  }


function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Card Authorization
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Status</h4>
          {
            props.isCardUpdated
            ?<h5>Card Authorization Successfull</h5>
            :<h5>Card Update and Authorization Successfull</h5>
          }          
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>OK</Button>
        </Modal.Footer>
      </Modal>
    );
  }


export default function Referral() {
    const [modalShow, setModalShow] = React.useState(false);
   
    const [isOpen1, setIsOpen1] = useState(false);
  
   
    const toggle1 = () => setIsOpen1(!isOpen1);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipOpenExpire, setTooltipOpenExpire] = useState(false);
    const [tooltipOpenCvv, setTooltipOpenCvv] = useState(false);
    const [tooltipOpenZipcode, setTooltipOpenZipcode] = useState(false);


    const [username,setusername]=useState('')
    const [validated,setValidated]=useState(false);
    const [EzzId,setEzzId]=useState('')

    const [CardNumber, setCardNumber]=useState(' ');
    const [ExpiryMonth,setExpiryMonth]=useState(' ');
    const [ExpiryYear ,setExpiryYear]=useState(' ');
    const [CVV ,setCVV]=useState(' ');
    const [monthList, setMonthList]=useState([])
    const [yearList, setYearList]=useState([])
    const [isCardAdded, setIsCardAdded]=useState(false)
    const [currCardNumber, setCurrCardNumber]=useState('')
    const [currCardType, setCurrCardType]=useState('')
    const [currCardExpiry, setCurrCardExpiry]=useState('')
    const [errorCard, setErrorCard] = useState('')
    const [isCardUpdated, setIsCardUpdated] = useState(false)
    const [isAddress, setIsAddress] = useState(false)
    
    const [FriendName, setFriendName]=useState(' ');
    const [FriendPhone,setFriendPhone]=useState(' ');
    const [FriendEmail ,setFriendEmail]=useState(' ');
      const[Country,setCountry]=useState('');
      const [Details,setDetails]=useState([]);
      const [State,setState]=useState([]);
 const [TeleCode,setTeleCode]=useState('');
const [CountryCode,setCountryCode]=useState('');
const [PhoneLength,setPhoneLength]=useState('');
const [RefMsg,setRefMsg]=useState('');
const [Nation,setNation]=useState('')
const [errorMessage, setErrorMessage] = useState('')
const[Phone,setPhone]=useState('');
    // console.log("tempMonth",tempMonth);
  

  const toggle2 = () => setTooltipOpen(!tooltipOpen);
  const toggleexpire = () => setTooltipOpenExpire(!tooltipOpenExpire);
  const toggleCvv = () => setTooltipOpenCvv(!tooltipOpenCvv);
  const togglezipcode = () => setTooltipOpenZipcode(!tooltipOpenZipcode);

//   const fetchUserCardDetails = async () => {

//     // const { data } = await Axios.post(base_url+`customer_card_info/`)

//     var ezz_id = localStorage.getItem('ezzyid')
    
//     await Axios({
//       method: 'POST',
//       url: base_url+`customer_card_info`,
//       data: {"ezz_id": ezz_id},
//       headers: {'Content-Type': 'application/json' }
//     })
//     .then(function (response) {
//       //handle success
//         console.log(response.data);   
//         setCurrCardNumber(response.data.Card_number)
//         setCurrCardType(response.data.Card_type)
//         setCurrCardExpiry(response.data.Expiry_date)
//         setIsCardAdded(true)    
  
//       })
//       .catch(function (response) {
//           //handle error
//           console.log(response);
//           // toast.warn('Some Error! Please try again');
//       });
    
// }


//   const handleUpdateCard = async () => {

//     console.log(EzzId);
//     console.log(CardNumber);
//     // console.log(`EXPIRYYYYYYY:::::20${ExpiryYear}-${ExpiryMonth}`);                     //WHEN YY
//     console.log(`EXPIRYYYYYYY:::::${ExpiryYear}-${ExpiryMonth}`);                        //WHEN YYYY
//     console.log("cvv", CVV);

//    await Axios({
//         method:"post",
//         url: base_url+"update_card_details",
//         data: {
//             "ezz_id": EzzId,
//             "card_number": CardNumber,
//             "expiry_date": ExpiryYear+"-"+ExpiryMonth,
//             "cvv": CVV
//         }
//     }).then(function(response){
//         console.log(response);


//         setIsCardUpdated(true)
//         setModalShow(true)
//         // returning same profile id and payment profile id
//         //  Axios({
//         //     method: "post",
//         //     url: base_url+"authorize_credit_card",
//         //     data:{
//         //         "ezz_id": EzzId
//         //     }
        
//         // }).then(function(response){
//         //   setModalShow(true);
//         //     console.log(response);
//         // }).catch(function(response){
//         //     console.error(response);
//         // })

//     }).catch(function(response){
//         console.log(response);
//         toast.error(response.error);
//         toast.error(response.description);
//         toast.error('INVALID DETAILS');
//         var errorMsg1 = response.error
//         var errorMsg2 = response.description
//         var errorMsg = errorMsg1 + errorMsg2
//         console.log('errorMsg',errorMsg);
//         // setErrorCard(errorMsg)
//         // setErrorCard('INVALID DETAILS')
        
//     })

//   }

//   const checkUserAddress = () => {

//     Axios({
//       method: 'get',
//       url: base_url+`customers/${localStorage.getItem('ezzyid')}/`,
//       headers: { 'Content-Type': 'application/json' }
//     }).then(function(response){
//       console.log(response)
//       console.log(response.data)

//       const userDetails =  response.data

//       setIsAddress(response.data.state)

//     }).catch(function(response){
//       console.log(response);
//     })  

//   }  

  const handleChangePhone=(event)=>{
   // console.log(event.length, 'length of event is');
  //  setErrorNotVerified("")
   setErrorMessage("")
   setPhone(event.target.value);

}


    const fetchcountries=async e=>{
            const {data}=await Axios.get(base_url + 'country_state_details/')
            console.log(data)
            setDetails(data);
            
        }

  useEffect(()=>{

    setusername(localStorage.getItem('username'));
    setValidated(localStorage.getItem('validated'));
    setEzzId(localStorage.getItem('ezzyid'));
    var temp_month = []
    for(var i=1; i<=12; i++ )
      temp_month.push(i)
    setMonthList(temp_month)

    var temp_year = []
    var curr_year = (new Date()).getFullYear()
    for(var i=0; i<10; i++){
      var new_year = (curr_year+i).toString()
      // new_year = new_year.substring(2)
      temp_year.push(new_year)
    }
      
      
    console.log('temp_year',temp_year);  
    setYearList(temp_year)
    fetchcountries();
    //fetchUserCardDetails()
    //checkUserAddress()
  
   },[])

  const handleChangeCountry=(event)=>{
  setCountry(event.target.value);
  document.getElementById('Phone').value = ''

    Details.map(keys=>{
      
      if(keys.name===event.target.value){
        setState(keys.states);
       setCountryCode(keys.telecode);
      setPhoneLength(keys.tele_length);
       console.log(`Telecode Isss ${keys.telecode}`)
       setNation(keys.country_id);
       console.log(keys.country_id)
        console.log(keys.states)
        setTeleCode(keys.telecode);
        console.log(keys.telecode)
      }
    })
  }

    const handleFormSubmit=async (e)=>{
       e.preventDefault();
    
    // console.log(FriendName);
    // console.log(EzzId);
   
    // console.log(FriendPhone);
    // console.log(FriendEmail);
    // console.log(base_url);
    let token = localStorage.getItem("token")
    //console.log('TOKEN',token)
    let header = {
      'Content-Type': 'application/json',
      'AUTHORIZATION': token,
    }

// ,headers: header
       Axios({
            method:'post',
            url:base_url+'verify_customer_email_phone/',
            data: {
            "email" : FriendEmail, 
            "phone" : FriendPhone, 
            "ezz_id" :EzzId
            },
            headers: {'Content-Type': 'application/json' }
          }).then(function(email){
            console.log(email);
            console.log('verification successful');
            if( email.data.Exist == "False")
            {  //email.data.Exist start

      Axios({
        method:"post",
        url: base_url+"customerreferral/",
        data: {
            "ezz_id": EzzId,
            "friend_name": FriendName,
            "friend_phone": FriendPhone,
            "friend_email": FriendEmail,
            "country": Nation,
            "status": "Pending"
        }
    }).then(function(response){
        console.log(response);
        // email send to customer
          // const emaildata={
          //   type : "referral_customer", 
          //   ezz_id :EzzId
          // }
          Axios({
            method:'post',
            url:base_url+'send_email/',
            data: {
            "ezz_id": EzzId,
            "friend_phone": FriendPhone,
            "type": "referral_customer"
            },
            headers: {'Content-Type': 'application/json' }
          }).then(function(email){
            console.log(email);
            console.log('email sent success');
          }).catch(function(email){
            console.log(email)
            console.log('email sending failed')
          })

        // email send to friend
          Axios({
            method:'post',
            url:base_url+'send_email/',
            data: {
            "ezz_id": EzzId,
            "friend_phone": FriendPhone,
            "type": "referral_friend"
            },
            headers: {'Content-Type': 'application/json' }
          }).then(function(email){
            console.log(email);
            console.log('email sent success');
          }).catch(function(email){
            console.log(email)
            console.log('email sending failed')
          })
		  
		  let promo_type = ''
		  let promo_value = ''
		  let promo_validity = ''
		  let promo_name = ''
		  
		  Axios({
            method:'post',
            url:base_url+'get_promtion_referral/',
            data: {
            "ezz_id": EzzId
            },
            headers: {'Content-Type': 'application/json' }
          }).then(function(respon){
            console.log(respon);
            console.log('email sent success');
			promo_type = respon.data.promo_type
			promo_value = respon.data.promo_value
			promo_validity = respon.data.promo_validity
			if ( promo_type == 'Weight' )
			{
				promo_value = promo_value.toString() + ' LBS'
			}else{
				promo_value = promo_value.toString() + ' %'
			}
			
			//toast.error('Congratulations! Referral Accepted.Email with a Signup link is sent to your referral.You will get a ' + promo_value + ' discount on ' + promo_type + ' Cost upon signup of your referral and their first shipping order within ' + promo_validity + ' Days of today date.');
      setRefMsg('Congratulations! Referral Accepted.Email with a Signup link is sent to your referral.You will get a ' + promo_value + ' discount on ' + promo_type + ' Cost upon signup of your referral and their first shipping order within ' + promo_validity + ' Days of today date.');
			
          }).catch(function(respon){
            console.log(respon)
            console.log('email sending failed')
          })
		  
        

    }).catch(function(response){
        console.log(response);
        toast.error('Sorry, the Phone Number/Email you just entered already exists in the system.Please add an alternate number to refer your friend!');
        
    })
    

            } //email.data.Exist end
            else
            {
              //toast.error('Oh! Already registered with us.Please refer another.');
              toast.error('Sorryyy, the Phone Number/Email you just entered already exists in the system.Please add an alternate number to refer your friend!');
            }
          }).catch(function(email){
            console.log(email)
            console.log('verification failed')
          })

        
         


   }

    return (
      <div>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6}>
		  <br/><br/>
            <h2 className="general-heading">Refer a friend and earn exciting rewards on your next order</h2>
          </Grid>

          <Grid item xs={3}>
            
          </Grid>
        </Grid><br/>

        <Container>
          <Row>
            <Col>
            <Form>
            
            <Row>
              <Col  lg={{ span: 8 }} >
              <h5 style={{color:"grey"}}>Enter Friend's Name</h5> 
                <InputGroup size="lg" >
                  <TextField   id="outlined-required" label="Name" onChange={(e) => setFriendName(e.target.value)}                   
                  placeholder="Enter friend's name" variant="outlined" fullWidth />
                  {/* <Input placeholder="Enter your Card Number" onChange={(e) => setCardNumber(e.target.value)} type="number" style={{ borderRadius: "3px", borderColor: "#58585f" }} /> */}
                </InputGroup>
              </Col>
            </Row><br/>
            <Row>
                      <Col lg={{ span: 8 }}  >
<h5 style={{ color: "grey" }}>Select Country</h5>
                      <FormControl variant="filled"  className='textField' fullWidth>
                        <InputLabel required htmlFor="selectCountry" id='selectCountry-label' >Country</InputLabel>
                        <Select required fullWidth
                          native                          
                          defaultValue="Select your Country"
                          onChange={handleChangeCountry}
                          inputProps={{
                            name: 'country',
                            id: 'selectCountry',
                          }}
                        >
                          <option aria-label="None" value="" />
                          {Details.map(key => {
                            return (
                              <option key={key.name}>{key.name}</option>
                            )
                          })}
                        </Select>
                      </FormControl>
                        
                        
                      </Col>
                    </Row><br/>
            <Row>
                                    <Col lg={{ span: 4 }}  >
                                    <h5 style={{ color: "grey" }}>Country Code</h5>
                        
                          <FormControl value={TeleCode} >
                            <TextField id="teleCode" placeholder="Code" label="" value={TeleCode} variant="filled" className='textField' fullWidth disabled 
                            InputProps={{
                              readOnly: true,
                            }}/>
                          </FormControl>
                        
                      </Col>
              <Col lg={{ span: 8 }} >
                <h5 style={{ color: "grey" }}>Enter Friend's Phone Number</h5>
                <FormControl onChange={handleChangePhone}>
                <TextField required id="Phone" placeholder="Enter friend's phone number" label="Phone Number" onChange={(e) => setFriendPhone(e.target.value)} variant="outlined" fullWidth type="number"/> 
                                              {
                              Phone.length > 0 && Phone.length < PhoneLength 
                              ?  <p style={{color:'red', fontSize: 'small'}}>*Please enter at least {PhoneLength} digit number</p>
                              :' '
                            }

                  </FormControl>
                {/* <InputGroup size="lg" >
                  <Input style={{ borderRadius: "3px", borderColor: "#58585f" }} />
                </InputGroup> */}
              </Col>
            </Row><br/>
            <Row>
              <Col  lg={{ span: 8 }} >
              <h5 style={{color:"grey"}}>Enter Friend's Email Address</h5> 
                <InputGroup size="lg" >
                  <TextField  required id="outlined-required" label="Email" onChange={(e) => setFriendEmail(e.target.value)}                   
                  placeholder="Enter friend's email address" variant="outlined" fullWidth />
                  {/* <Input placeholder="Enter your Card Number" onChange={(e) => setCardNumber(e.target.value)} type="number" style={{ borderRadius: "3px", borderColor: "#58585f" }} /> */}
                </InputGroup>
              </Col>
            </Row><br/>
            <Row>
                                  
              <Col lg={{ span: 12 }} >
                <FormControl >
                                <p style={{color:'green', fontWeight: 'bold',  fontSize: 'large'}}> {RefMsg} </p>
                  </FormControl>
              </Col>
            </Row><br/>
            <Row>
              <Col  lg={{ span: 2, offset: 4 }}  >
                {/*<Button variant='outline-info' size='lg' block>Cancel</Button>                          */}
              </Col>  {' '}
              <Col lg={{ span: 2 }}  >
                <Button variant='info' onClick={(e)=>handleFormSubmit(e)} size='lg' block>Send</Button>
                  
                
                
              </Col>
              <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)} />          
            </Row>
          </Form>   
            </Col>
           
          </Row>

       
        </Container>

       <ToastContainer/>
        </div>
    )
}
